import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";

import { UserSchema } from "../../Apollo/schema/get-people";

export const FollowupMessageSchema = z.object({
	message: z.string(),
	days: z.number(),
	customDate: z.boolean(),
});

export const FollowupMessagesSchema = z.object({
	reply1: FollowupMessageSchema,
	reply2: FollowupMessageSchema.optional(),
	reply3: FollowupMessageSchema.optional(),
});

export const CreateMessageTemplateSchema = z.object({
	name: z.string().nullable(),
	content: z.string(),
});

export const UpdateMessageTemplateSchema = CreateMessageTemplateSchema.extend({
	id: z.number(),
});

export const MessageTemplateSchema = CreateMessageTemplateSchema.extend({
	id: z.number(),
	createdAt: z.string(),
	updatedAt: z.string(),
	createdBy: UserSchema.optional(),
	updatedBy: UserSchema.optional(),
});

export const MessageTemplateResponseSchema = z.object({
	data: z.array(MessageTemplateSchema),
	meta: MetaDataSchema,
});

export type MessageTemplateResponse = z.infer<typeof MessageTemplateResponseSchema>;
export type MessageTemplate = z.infer<typeof MessageTemplateSchema>;
export type CreateMessageTemplate = z.infer<typeof CreateMessageTemplateSchema>;
export type UpdateMessageTemplate = z.infer<typeof UpdateMessageTemplateSchema>;
export type FollowupMessage = z.infer<typeof FollowupMessageSchema>;
export type FollowupMessages = z.infer<typeof FollowupMessagesSchema>;
